// extracted by mini-css-extract-plugin
module.exports =  {"title-field":"_1TDK4gy7uSWWL1LkrLt5eg","create-text":"_1T0Uy07lHbIHJ9EOmNVXPN","button-area":"_3eZHEI8D9_3YVVJ7DonbrK"};